import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from './authentication.service';
import { Observable } from 'rxjs';
const apiUrl = environment.serverUrl + 'api/';

@Injectable({
  providedIn: 'root'
})
export class TenantService {
  constructor(private http: HttpClient, private authenSer: AuthenticationService) { }


  getTenants() {
    let subUrl = this.authenSer.getUserApiTargetUrl();
    const url = apiUrl + subUrl + '/tenants';
    debugger;
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    return this.http.get(url, { withCredentials: true });
  }

  deleteTenant(id: any) {
    let subUrl = this.authenSer.getUserApiTargetUrl();
    const url = apiUrl + subUrl + '/tenants/' + id;
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    return this.http.delete(url, { withCredentials: true });

}

saveTenant(tenant): Observable<any> {
  let subUrl = this.authenSer.getUserApiTargetUrl();
  const url = apiUrl + subUrl + '/tenants';
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    return this.http.post(url, tenant, { withCredentials: true });
}

putTenant(tenant): Observable<any> {
  let subUrl = this.authenSer.getUserApiTargetUrl();
  const url = apiUrl + subUrl + '/tenants';
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    return this.http.put(url, tenant, { withCredentials: true });
}
getTenantById(tenantId) {
  let subUrl = this.authenSer.getUserApiTargetUrl();
  const url = apiUrl + subUrl + '/tenants/'+tenantId;
  let headers = new HttpHeaders();
  headers = headers.append('Content-Type', 'application/json');
  return this.http.get(url, { withCredentials: true });
}
}

